import z from 'zod';

export const GetCurationSnapsServiceRequestSchema = z
  .object({
    curationId: z.string(),
    page: z.number().int().min(1),
    size: z.number().int().min(1).max(100),
    snapId: z.string().optional(),
  })
  .describe('GetCurationSnapsServiceRequestSchema');

export type GetCurationSnapsServiceRequest = z.infer<typeof GetCurationSnapsServiceRequestSchema>;

export const CurationSnapDetailGoodsSchema = z
  .object({
    goodsNo: z.string(),
    goodsName: z.string(),
    brandId: z.string(),
    brandName: z.string(),
    brandLinkUrl: z.string(),
    linkUrl: z.string(),
    imageUrl: z.string(),
    normalPrice: z.number(),
    price: z.number(),
    couponPrice: z.number().nullish(),
    couponSalesRate: z.number().nullish(),
    extraDiscountAmount: z.number().nullish(),
    finalPrice: z.number().nullish(),
    finalDiscount: z.number().nullish(),
    isLowestPrice: z.boolean().nullish(),
    isExclusive: z.boolean(),
    salesRate: z.number(),
    isLiked: z.boolean(),
    isSoldOut: z.boolean(),
    hasOptionPrice: z.boolean().nullish(),
  })
  .describe('CurationSnapDetailGoodsSchema');

export const CurationSnapDetailItemSchema = z
  .object({
    id: z.string(),
    imageUrls: z.array(z.string()),
    linkUrl: z.string(),
    goods: z.array(CurationSnapDetailGoodsSchema).nullish(),
  })
  .describe('CurationSnapDetailItemSchema');

export const GetCurationSnapsServiceResponseSchema = z
  .object({
    curationId: z.string(),
    title: z.string(),
    description: z.string().nullish(),
    list: z.array(CurationSnapDetailItemSchema),
    total: z.number(),
    pagination: z.object({
      currentPage: z.number(),
      pageSize: z.number(),
      hasNextPage: z.boolean(),
      nextPage: z.number().optional(),
    }),
  })
  .describe('GetCurationSnapsServiceResponseSchema');

export type GetCurationSnapsServiceResponse = z.infer<typeof GetCurationSnapsServiceResponseSchema>;

export type CurationSnapDetailItem = z.infer<typeof CurationSnapDetailItemSchema>;
export type CurationSnapDetailGoodsItem = z.infer<typeof CurationSnapDetailGoodsSchema>;
